import DocumentStatesRequest from "../ws/states/DocumentStatesRequest";

export const DOCUMENT_STATE_UPDATE = 'document-state-update';

export const getDocumentStates = () => (dispatch) => {

  new DocumentStatesRequest()
    .onSuccess(data => {
      dispatch({
        type: DOCUMENT_STATE_UPDATE,
        payload: data.data,
      });
    })
    .execute();
};


// WEBPACK FOOTER //
// ./src/app/documents/actions/documentStatesActions.js